import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mto_component_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mto_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mto_section_guid : fromDatatype.GuidDataFieldInterface;
  image_guid: fromDatatype.GuidDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  component_code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  currency : fromDatatype.VarcharDatatypeInterface;
  unit_price_with_tax: fromDatatype.NumericDatatypeInterface
  is_compulsory: boolean;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pricing_logic: fromDatatype.VarcharDatatypeInterface;
  aggregate_qty_max: fromDatatype.IntegerDatatypeInterface;
  aggregate_qty_min: fromDatatype.IntegerDatatypeInterface;
  treatment_json: fromDatatype.JsonDatatypeInterface;
  label_hdr_guid: fromDatatype.GuidDataFieldInterface;
  aggregate_amount_max: fromDatatype.NumericDatatypeInterface;
  aggregate_amount_min: fromDatatype.NumericDatatypeInterface;
}

export class bl_fi_mto_component_hdr_RowClass implements bl_fi_mto_component_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mto_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mto_section_guid : fromDatatype.GuidDataFieldInterface;
  image_guid: fromDatatype.GuidDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  component_code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  currency : fromDatatype.VarcharDatatypeInterface;
  unit_price_with_tax: fromDatatype.NumericDatatypeInterface
  is_compulsory: boolean;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pricing_logic: fromDatatype.VarcharDatatypeInterface;
  aggregate_qty_max: fromDatatype.IntegerDatatypeInterface;
  aggregate_qty_min: fromDatatype.IntegerDatatypeInterface;
  treatment_json: fromDatatype.JsonDatatypeInterface;
  label_hdr_guid: fromDatatype.GuidDataFieldInterface;
  aggregate_amount_max: fromDatatype.NumericDatatypeInterface;
  aggregate_amount_min: fromDatatype.NumericDatatypeInterface;
}
